import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';

import { CHECKBOX_FILTERS } from '../constants';
import { buildSelectItems } from '../utils';
import Select from '../../Select';
import FilterSelectButton from './FilterSelectButton';

const FilterSelect = ({
	disabled,
	category,
	filters,
	openedFilterSelects,
	handleFilterSelectOpen,
	handleFilterCheck
}) => {
	const checkedFilters = useSelector(state => state.filterbar.checkedFilters);
	const buttonId = 'Filters__' + category + '_select_button';
	const listId = 'Filters__' + category + '_select_list';
	const inputId = category + '-select-input';

	return (
		<FormControl>
			<Select
				button={
					<FilterSelectButton
						disabled={disabled}
						active={checkedFilters[category].length > 0}
						id={buttonId}
						htmlFor={inputId}
						onClick={() => handleFilterSelectOpen(category)}>
						{CHECKBOX_FILTERS.find(filterGroup => filterGroup.name === category).label}
					</FilterSelectButton>
				}
				disabled={disabled}
				buttonId={buttonId}
				listId={listId}
				value={checkedFilters[category]}
				items={buildSelectItems(filters, checkedFilters)}
				multiple
				open={openedFilterSelects.indexOf(category) !== -1}
				onOpen={() => handleFilterSelectOpen(category)}
				onClose={() => handleFilterSelectOpen(category)}
				onChange={e => handleFilterCheck(category, e.target.value)}
				input={<Input id={inputId} />}
				renderValue={selected => selected.join(', ')}
			/>
		</FormControl>
	);
};

FilterSelect.propTypes = {
	disabled: PropTypes.bool,
	category: PropTypes.string.isRequired,
	filter: PropTypes.arrayOf(PropTypes.object).isRequired,
	openedFilterSelects: PropTypes.arrayOf(PropTypes.string).isRequired,
	handleFilterSelectOpen: PropTypes.func.isRequired,
	handleFilterCheck: PropTypes.func.isRequired
};

export default FilterSelect;
